export * from './htlm-editor-component-config.interface';
